import { render, staticRenderFns } from "./img_list.vue?vue&type=template&id=0084fab0&"
import script from "./img_list.vue?vue&type=script&lang=js&"
export * from "./img_list.vue?vue&type=script&lang=js&"
import style0 from "./img_list.vue?vue&type=style&index=0&lang=less&scepod=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0084fab0')) {
      api.createRecord('0084fab0', component.options)
    } else {
      api.reload('0084fab0', component.options)
    }
    module.hot.accept("./img_list.vue?vue&type=template&id=0084fab0&", function () {
      api.rerender('0084fab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/img_list.vue"
export default component.exports